import React from 'react';
import { useFocusIdx } from '@bay-email/editor';

import { Padding } from '../../attributes/Padding';
import { BackgroundColor } from '../../attributes/BackgroundColor';
import { Color } from '../../attributes/Color';
import { TextAreaField } from '../../../../components/Form';
import { FontSize } from '../../attributes/FontSize';
import { FontWeight } from '../../attributes/FontWeight';
import { FontFamily } from '../../attributes/FontFamily';
import { LineHeight } from '../../attributes/LineHeight';
import { AttributesPanelWrapper } from '../../attributes/AttributesPanelWrapper';
import { Collapse, Grid, Space } from '@arco-design/web-react';

export function AccordionText() {
	const { focusIdx } = useFocusIdx();

	return (
		<AttributesPanelWrapper>
			<Collapse defaultActiveKey={['0', '1', '2']}>
				<Collapse.Item
					name='0'
					header={t('Setting')}
				>
					<div className='px-2 py-3'>
						<TextAreaField
							label={t('Content')}
							name={`${focusIdx}.data.value.content`}
							autoSize={{ minRows: 5 }}
						/>
						<Color />
						<FontSize />
						<LineHeight />
						<FontWeight />
						<FontFamily />
						<BackgroundColor />
						<Padding
							title={t('Padding')}
							attributeName='padding'
						/>
					</div>
				</Collapse.Item>
			</Collapse>
		</AttributesPanelWrapper>
	);
}
